type Props = {
  width?: string;
  height?: string;
  viewBox?: string;
  strokeColor?: string;
  /** Overrides the color of the document's edit lines only (page, fold and
      pencil keep `strokeColor`). */
  linesColor?: string;
};

/**
 * Track-changes / revisions glyph — a document with edit lines and an
 * overlapping pencil (Word's "Track Changes" affordance). Used by the
 * transcript toolbar's redlines toggle; clearer than the abstract
 * squiggle glyph it replaced (`TranscriptHistoryIcon`).
 */
const TrackChangesIcon = (props: Props) => {
  const {
    width = '16',
    height = '16',
    viewBox = '0 0 24 24',
    strokeColor = 'currentColor',
    linesColor,
  } = props;
  return (
    <svg
      width={width}
      height={height}
      viewBox={viewBox}
      fill="none"
      stroke={strokeColor}
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    >
      <path d="M14.5 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h4.5" />
      <polyline points="14 2 14 8 20 8" />
      <line x1="8" y1="13" x2="11.5" y2="13" stroke={linesColor} />
      <line x1="8" y1="17" x2="9.5" y2="17" stroke={linesColor} />
      <path d="M18.4 11.6a1.8 1.8 0 0 1 2.5 2.5L14.5 20.5 11 21.5l1-3.5 6.4-6.4z" />
    </svg>
  );
};

export default TrackChangesIcon;
